module.exports = __webpack_public_path__ + "img/game_verification_1_ru.8733d967.png";